import React from 'react';
import { Link } from 'react-router-dom';

const WhitelabelLayout = ({ children, organizer }) => {
    // Aplicamos los colores de marca dinámicamente
    const brandColor = organizer?.brandColor || '#72c02c'; // Verde por defecto si no hay uno
    const logoUrl = organizer?.logoUrl;
    const organizerName = organizer?.firstName ? `${organizer.firstName} ${organizer.lastName}` : 'Organizador';

    return (
        <div className="min-h-screen bg-slate-50 font-sans" style={{ '--primary-brand': brandColor }}>
            {/* Custom Navbar del Organizador */}
            <nav className="bg-white border-b border-slate-200 sticky top-0 z-50 h-28 shadow-sm transition-all duration-300">
                <div className="max-w-7xl mx-auto px-4 h-full flex items-center justify-between gap-4">
                    <Link to={`/o/${organizer.slug}`} className="flex items-center gap-3 md:gap-4 min-w-0 group">
                        {logoUrl ? (
                            <img 
                                src={logoUrl} 
                                alt={organizerName} 
                                className="h-20 md:h-24 w-auto object-contain flex-shrink-0 drop-shadow-sm group-hover:scale-105 transition-transform duration-300" 
                            />
                        ) : (
                            <div className="flex items-center gap-2 min-w-0">
                                <div
                                    className="w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center text-white font-bold text-lg md:text-xl shadow-lg flex-shrink-0"
                                    style={{ backgroundColor: brandColor }}
                                >
                                    {organizerName.charAt(0)}
                                </div>
                                <span className="font-bold text-base md:text-xl text-slate-800 tracking-tight truncate max-w-[120px] md:max-w-xs">
                                    {organizerName}
                                </span>
                            </div>
                        )}
                    </Link>

                    <div className="flex items-center gap-3 md:gap-6 flex-shrink-0">
                        <a
                            href={`/o/${organizer.slug}#eventos`}
                            className="text-[13px] md:text-[15px] font-semibold text-slate-600 hover:text-[var(--primary-brand)] transition-colors"
                        >
                            Pozos
                        </a>
                        <Link
                            to="/login"
                            className="bg-[var(--primary-brand)] text-white px-4 py-2 md:px-6 md:py-2.5 rounded-xl font-bold text-[12px] md:text-[14px] shadow-lg shadow-[var(--primary-brand)]/20 hover:scale-105 transition-all whitespace-nowrap"
                        >
                            Entrar
                        </Link>
                    </div>
                </div>
            </nav>

            {/* Content Area */}
            <main className="animate-in fade-in duration-500">
                {children}
            </main>

            {/* Footer simplificado Marca Blanca */}
            <footer className="bg-white border-t border-slate-200 py-12 mt-12">
                <div className="max-w-7xl mx-auto px-4 flex flex-col items-center">
                    <span className="text-slate-400 text-sm mb-2">
                        Gestionado por
                    </span>
                    <span className="font-bold text-lg text-slate-700">
                        {organizerName}
                    </span>
                    <div className="mt-8 pt-8 border-t border-slate-100 w-full text-center">
                        <p className="text-slate-400 text-xs">
                            Potenciado por VisioPadel &copy; {new Date().getFullYear()}
                        </p>
                    </div>
                </div>
            </footer>

            {/* Inyección de estilos dinámicos para clases de Tailwind personalizadas */}
            <style dangerouslySetInnerHTML={{
                __html: `
                .text-primary-brand { color: var(--primary-brand); }
                .bg-primary-brand { background-color: var(--primary-brand); }
                .border-primary-brand { border-color: var(--primary-brand); }
                .hover\\:text-primary-brand:hover { color: var(--primary-brand); }
                .hover\\:bg-primary-brand:hover { background-color: var(--primary-brand); }
            `}} />
        </div>
    );
};

export default WhitelabelLayout;
